import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import React from "react";
import faqsByRoute from "../FAQ/faqsByRoute";

/* -----------------------------
   Extract text from JSX
----------------------------- */
function extractText(node) {
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map(extractText).join(" ");
  if (React.isValidElement(node)) return extractText(node.props.children);
  return "";
}

/* -----------------------------
   Normalize path
----------------------------- */
function normalizePath(path) {
  if (!path) return "/";
  return path.replace(/\/+$/, "") || "/";
}

/* -----------------------------
   Match route intelligently
----------------------------- */
function findMatchingFaq(pathname) {
  const normalized = normalizePath(pathname);

  // exact match first
  if (faqsByRoute[normalized]) return faqsByRoute[normalized];

  // prefix match (for nested routes)
  const matchKey = Object.keys(faqsByRoute).find(
    (route) => route !== "/" && normalized.startsWith(route)
  );

  return matchKey ? faqsByRoute[matchKey] : null;
}

/* -----------------------------
   Component
----------------------------- */
export default function FaqSchema() {
  const location = useLocation();

  useEffect(() => {
    const faqContent = findMatchingFaq(location.pathname);
    if (!faqContent?.items?.length) return;

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqContent.items.map((faq) => ({
        "@type": "Question",
        name: extractText(faq.q).replace(/^\d+\.\s*/, ""),
        acceptedAnswer: {
          "@type": "Answer",
          text: extractText(faq.a).slice(0, 500),
        },
      })),
    };

    const SCRIPT_ID = "faq-schema-jsonld";

    // HARD BLOCK — if already exists, replace it safely
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = SCRIPT_ID;
    script.textContent = JSON.stringify(schema);

    document.head.appendChild(script);

    // cleanup on route change / unmount
    return () => {
      const old = document.getElementById(SCRIPT_ID);
      if (old) old.remove();
    };
  }, [location.pathname]);

  return null;
}